import React, { createContext, FC, ReactNode, useContext, useMemo } from 'react';

interface AvatarDisplayContextValue {
  showImages: boolean;
}

const AvatarDisplayContext = createContext<AvatarDisplayContextValue>({
  showImages: false
});

interface AvatarDisplayProviderProps {
  children: ReactNode;
  showImages?: boolean;
}

export const AvatarDisplayProvider: FC<AvatarDisplayProviderProps> = ({ children, showImages = false }) => {
  const value = useMemo(() => ({ showImages }), [showImages]);

  return <AvatarDisplayContext.Provider value={value}>{children}</AvatarDisplayContext.Provider>;
};

export const useAvatarDisplay = () => useContext(AvatarDisplayContext);
